module.exports = __webpack_public_path__ + "4811d56b9210c3bb045c51f8c386e983.jpg";